import { Link } from "react-router-dom";
import { timelineUpdates } from "@/mocks/gossip";

function statusClass(status: string) {
  if (status === "已确认") return "bg-primary-100 text-primary-800";
  if (status === "已回应") return "bg-secondary-100 text-secondary-900";
  return "bg-accent-100 text-accent-800";
}

export default function FollowTimeline() {
  return (
    <section className="w-full bg-background-50" aria-labelledby="timeline-title">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-24">
              <span className="mb-2 inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium tracking-wide text-accent-800">
                <i className="ri-time-line text-sm" aria-hidden="true"></i>
                蹲后续示范
              </span>
              <h2
                id="timeline-title"
                className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl"
              >
                一条瓜的完整时间线
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                以今天讨论度最高的一件事为例。我们把从爆料出现到当事人回应的每一步按顺序列出，并标注每条的确认状态，反转与否一眼就能看出。
              </p>
              <div className="mt-6 flex flex-wrap gap-2">
                <span className="rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">
                  已确认
                </span>
                <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
                  已回应
                </span>
                <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
                  待核实
                </span>
              </div>
              <Link
                to="/plaza"
                className="mt-6 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
              >
                看更多时间线
                <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
              </Link>
            </div>
          </div>

          <ol className="relative lg:col-span-8">
            <span
              className="absolute left-[7px] top-2 h-[calc(100%-1rem)] w-px bg-background-300"
              aria-hidden="true"
            ></span>
            {timelineUpdates.map((item) => (
              <li key={item.id} className="relative flex gap-5 pb-8 last:pb-0">
                <span className="relative z-10 mt-1.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full border-2 border-background-50 bg-primary-500"></span>
                <div className="min-w-0 flex-1 rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
                  <div className="flex flex-wrap items-center gap-3">
                    <span className="font-heading text-sm font-bold text-foreground-950">
                      {item.time}
                    </span>
                    <span
                      className={`rounded-full px-2 py-0.5 text-[11px] font-medium ${statusClass(item.status)}`}
                    >
                      {item.status}
                    </span>
                  </div>
                  <h3 className="mt-2 font-heading text-base font-bold text-foreground-900">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.text}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}